module.exports = __webpack_public_path__ + "img/logo.6d0c3de9.svg";